<div class="fluffy">
    <i [ngClass]="enableNewPrebuyIcons ? 'theme-bingo-gala-minus' : 'theme-minus'" [ngClass]="AppendClass(0)" (click)="onMinusclick()"></i>
    <mat-slider
        min="{{ min }}"
        max="{{ max }}"
        step="{{ step }}"
        discrete
        tickInterval="auto"
        class="cdk-focused"
        [displayWith]="formatLabel.bind(this)">
        <input value="{{ value }}" matSliderThumb thumbLabel (valueChange)="OnValueChanged($event)" />
    </mat-slider>
    <div class="multiPrice-slider">
        <div class="multiprice-selection-slider priceIndex">
            <span
                class="muti-price-cnt"
                *ngFor="let multiPrice of numbers; let i = index"
                [ngStyle]="currentindex != i ? { opacity: 0.4 } : ''"
                (click)="OnValueChangedInput(multiPrice)"
                >{{ multiPrice }}</span
            >
        </div>
    </div>
    <i [ngClass]="enableNewPrebuyIcons ? 'theme-bingo-gala-plus' : 'theme-plus'" [ngClass]="AppendClass(1)" (click)="onPlusclick()"></i>
</div>
